import React from "react";
import { Box, Stack, Typography } from "@mui/material";

const itemTitleSx = {
  color: "#333",
  fontWeight: 700,
  fontSize: { xs: "1.125rem", sm: "1.25rem", md: "1.5rem" },
};

const itemDescriptionSx = {
  color: "#767676",
  fontWeight: 400,
  fontSize: { xs: "0.9375rem", sm: "1rem", md: "1.125rem" },
};

const WhyChooseUs = () => {
  const whyChooseUs = [
    {
      title: "Efficient Coordination",
      description: "Seamlessly match your shipments with the right carriers.",
      image: "/assets/landingPageIcons/WCU-effecient-coordination.svg",
    },
    {
      title: "Real-Time Tracking",
      description: "Gain complete visibility into your good's journey.",
      image: "/assets/landingPageIcons/WCU-realtime-tracking.svg",
    },
    {
      title: "Cost Optimization",
      description: "Reduce expenses and improve your bottom line.",
      image: "/assets/landingPageIcons/WCU-cost-optimization.svg",
    },
    {
      title: "Seamless Experience",
      description: "Stay on top of regulations with our automated tools.",
      image: "/assets/landingPageIcons/WCU-seamless-experience.svg",
    },
    {
      title: "Secure Data",
      description:
        "Your Data is 100% secure with us and used only for fulfillment of services offered",
      image: "/assets/landingPageIcons/WCU-secure-data.svg",
    },
  ];

  return (
    <Box
      id="whyChooseUs"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        background: "#FFF",
        paddingBlock: { xs: "2.5rem", md: "3rem" },
        px: { xs: 2.5, md: 0 },
      }}
    >
      <Typography
        sx={{
          color: "#333",
          marginBottom: "1.5rem",
          fontSize: { xs: "2rem", md: "2.25rem" },
          fontWeight: 700,
          textAlign: "center",
        }}
      >
        Why Choose Us
      </Typography>
      <Typography
        maxWidth="lg"
        textAlign="center"
        color="#333"
        sx={{ fontSize: { xs: "1.0625rem", sm: "1.25rem", md: "1.5rem" } }}
      >
        The LoadEazy Team, with over 50 years of experience in the steel
        industry, deeply understands its complexities and challenges. Our
        solution is carefully designed to transform the transportation of steel
        products, placing a high priority on both convenience and safety.
      </Typography>
      <Typography
        maxWidth="lg"
        textAlign="center"
        color="#333"
        mt={2}
        mb={2}
        sx={{ fontSize: { xs: "1.0625rem", sm: "1.25rem", md: "1.5rem" } }}
      >
        The primary objective of our platform is to create data driven decision
        support mechanism for an efficient logistics system, in line with the
        National Logistics Policy.
      </Typography>
      <Stack
        direction="row"
        justifyContent="center"
        maxWidth="xl"
        gap={{ xs: "32px", sm: "40px", md: "56px" }}
        m="auto"
        flexWrap="wrap"
      >
        {whyChooseUs.map((item) => (
          <Box
            key={item.title}
            sx={{
              width: { xs: "100%", sm: "220px", md: "256px" },
              mx: "auto",
              textAlign: "center",
            }}
          >
            <Box
              component="img"
              src={item.image}
              alt={item.title}
              sx={{
                width: { xs: "96px", sm: "130px", md: "180px" },
                height: "auto",
              }}
            />
            <Typography sx={itemTitleSx}>{item.title}</Typography>
            <Typography sx={itemDescriptionSx}>{item.description}</Typography>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default WhyChooseUs;